<template>
  <repeated-modal v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import RepeatedModal from "../RepeatedModal.vue";

export default {
  name: "repeated-modal-wrapper",
  components: {
    "repeated-modal": RepeatedModal
  }
}
</script>
